import Padding from "../../../../content/posts/2021-09-01-spacing-margin-padding/Padding.js";
import Padded from "../../../../content/posts/2021-09-01-spacing-margin-padding/Padded.js";
import Centered from "../../../../content/posts/2021-09-01-spacing-margin-padding/Centered.js";
import * as React from 'react';
export default {
  Padding,
  Padded,
  Centered,
  React
};